import React, { useEffect, useState } from "react";
import { trackMetaPixelRegistration } from "../utils/metaPixel";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import {
  getBotAccessList,
  registerTeacher,
} from "../features/student/redux/studentThunk";
import LoaderOverlay from "./LoaderOverlay";
import { motion } from "framer-motion";
import { clearGoogleAndMobile } from "../features/QuestionPaper/createpaper/components/registration/redux/registerSlice";
export default function IndividualRegistrationForm({ stopAudio }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, botAccess } = useSelector((state) => state.student);
  const { googleEmail, mobile, adminName } = useSelector(
    (state) => state.register,
  );
  const [searchParams] = useSearchParams();

  const [formData, setFormData] = useState({
    name: "",
    city: "",
    email: googleEmail || "",
    contactNumber: mobile || "",
    password: "",
    confirmPassword: "",
    associatedSchool: "",
    schoolName: "",
    referralCode: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [phoneError, setPhoneError] = useState("");

  const { state } = useLocation();
  // const registerType = state?.register_type;
  const registerType = state?.register_type
    ? state?.register_type
    : "direct_signup_page";

  useEffect(() => {
    const refCode = searchParams.get("ref");

    if (refCode && /^[a-zA-Z0-9]{8}$/.test(refCode)) {
      setFormData((prev) => ({
        ...prev,
        referralCode: refCode,
      }));
    }
  }, [searchParams]);

  useEffect(() => {
    if (googleEmail) {
      setFormData((prev) => ({
        ...prev,
        email: googleEmail,
      }));
    }

    if (mobile) {
      setFormData((prev) => ({
        ...prev,
        contactNumber: mobile,
      }));
    }
    if (adminName) {
      setFormData((prev) => ({
        ...prev,
        name: adminName,
      }));
    }
  }, [googleEmail, mobile, adminName]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    dispatch(getBotAccessList());
  }, [dispatch]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (stopAudio) stopAudio();

    if (!/^\d{10}$/.test(formData.contactNumber)) {
      setPhoneError("Phone number must be exactly 10 digits");
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match!");
      return;
    }
    if (formData.associatedSchool === "yes" && !formData.schoolName.trim()) {
      alert("Please enter the school name.");
      return;
    }

    // const payload = {
    //   username: formData.name,
    //   city: formData.city,
    //   email: formData.email,
    //   password: formData.password,
    //   contact_number: formData.contactNumber,
    //   associated_school: formData.associatedSchool === "yes" ? true : false,
    //   school_name:
    //     formData.associatedSchool === "yes" ? formData.schoolName : "",
    //   account_type: "individual",
    //   // role: "teacher",
    //   registrationDate: new Date().toISOString().split("T")[0],
    // };

    const payload = {
      schoolName:
        formData.associatedSchool === "yes" ? formData.schoolName : "",
      email: formData.email,
      contactNumber: formData.contactNumber,
      adminName: formData.name,
      password: formData.password,
      confirmPassword: formData.confirmPassword,
      address: formData.city,
      city: formData.city,
      schoolType: "other",
      role: "teacher",
      accountType: "other",
      registerType: registerType || "",
      referralCode: formData.referralCode || null,
    };

    dispatch(registerTeacher(payload))
      .unwrap()
      .then((res) => {
        console.log("✅ Teacher registration success:", res);
        trackMetaPixelRegistration(); //provided by ankith
        dispatch(clearGoogleAndMobile());
        // alert("✅ Registration success");
        alert(
          "OTP has been sent to your email. Please verify to complete registration.",
        );
        navigate("/otp", {
          state: {
            formData: payload,
            isWhatsapp: botAccess?.isWhatsapp,
            isEmailSuccessful: botAccess?.isEmailSuccessful,
            isSMS: botAccess?.isSMS,
          },
        });
        //navigate("/login");
      })
      .catch((err) => {
        console.error("❌ Registration failed:", err);
        alert("❌ Registration failed:" + err);
      });
  };

  return (
    <div style={{ position: "relative" }}>
      {loading && <LoaderOverlay />}

      <motion.form
        onSubmit={handleSubmit}
        animate={{ opacity: loading ? 0.4 : 1 }}
        transition={{ duration: 0.3 }}
      >
        <div className="mb-2">
          <input
            type="text"
            name="name"
            placeholder="Name of Person"
            required
            value={formData.name}
            onChange={handleChange}
            className="form-control"
            disabled={!!adminName}
          />
        </div>

        <div className="mb-2">
          <input
            type="text"
            name="city"
            placeholder="City"
            required
            value={formData.city}
            onChange={handleChange}
            className="form-control"
          />
        </div>

        <div className="mb-2">
          <input
            type="email"
            name="email"
            placeholder="Email ID"
            required
            value={formData.email}
            disabled={!!googleEmail}
            onChange={handleChange}
            className="form-control"
          />
        </div>

        {/* <div className="mb-2">
        <input
          type="text"
          name="contactNumber"
          placeholder="Contact Number"
          required
          value={formData.contactNumber}
          onChange={handleChange}
          className="form-control"
        />
      </div> */}
        <div className="mb-2">
          <input
            type="text"
            name="contactNumber"
            placeholder="Contact Number"
            required
            maxLength={10}
            disabled={!!mobile}
            value={formData.contactNumber}
            onChange={(e) => {
              const value = e.target.value;

              // Allow only digits
              if (/^\d*$/.test(value)) {
                setFormData({ ...formData, contactNumber: value });
                if (value.length !== 10) {
                  setPhoneError("Phone number must be exactly 10 digits");
                } else {
                  setPhoneError("");
                }
              }
            }}
            className="form-control"
          />
          {phoneError && (
            <small style={{ color: "red", fontSize: "12px" }}>
              {phoneError}
            </small>
          )}
        </div>

        <div className="mb-2 position-relative">
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            placeholder="Password"
            required
            value={formData.password}
            onChange={handleChange}
            className="form-control"
          />
          <i
            className={`fa-solid ${
              showPassword ? "fa-eye-slash" : "fa-eye"
            } position-absolute`}
            style={{
              right: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#555",
            }}
            onClick={() => setShowPassword(!showPassword)}
          ></i>
        </div>

        {/* Confirm Password field with eye icon */}
        <div className="mb-2 position-relative">
          <input
            type={showConfirmPassword ? "text" : "password"}
            name="confirmPassword"
            placeholder="Confirm Password"
            required
            value={formData.confirmPassword}
            onChange={handleChange}
            className="form-control"
          />
          <i
            className={`fa-solid ${
              showConfirmPassword ? "fa-eye-slash" : "fa-eye"
            } position-absolute`}
            style={{
              right: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#555",
            }}
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          ></i>
        </div>
        <div className="mb-2">
          <input
            type="text"
            name="referralCode"
            placeholder="Referral Code (Optional)"
            value={formData.referralCode}
            maxLength={8}
            onChange={(e) => {
              const value = e.target.value;

              // allow only alphanumeric
              if (/^[a-zA-Z0-9]*$/.test(value)) {
                setFormData({ ...formData, referralCode: value });
              }
            }}
            className="form-control"
          />
          {formData.referralCode &&
            !/^[a-zA-Z0-9]{8}$/.test(formData.referralCode) && (
              <small style={{ color: "red", fontSize: "12px" }}>
                Referral code must be exactly 8 alphanumeric characters
              </small>
            )}
        </div>

        {/* Associated with School */}
        <div
          className="mb-2"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            flexWrap: "nowrap",
          }}
        >
          <label
            className="form-label fw-normal mb-0"
            style={{
              fontSize: "14px", // smaller font
              marginRight: "10px",
              whiteSpace: "nowrap",
            }}
          >
            Associated with School?
          </label>

          <label
            className="mb-0"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              fontSize: "14px",
            }}
          >
            <input
              type="radio"
              name="associatedSchool"
              value="yes"
              checked={formData.associatedSchool === "yes"}
              onChange={handleChange}
              required
            />
            Yes
          </label>

          <label
            className="mb-0"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              fontSize: "14px",
            }}
          >
            <input
              type="radio"
              name="associatedSchool"
              value="no"
              checked={formData.associatedSchool === "no"}
              onChange={handleChange}
              required
            />
            No
          </label>
        </div>

        {/* Conditionally show school name input */}
        {formData.associatedSchool === "yes" && (
          <div className="mb-2">
            <input
              type="text"
              name="schoolName"
              placeholder="Name of the School"
              required={formData.associatedSchool === "yes"}
              value={formData.schoolName}
              onChange={handleChange}
              className="form-control"
            />
          </div>
        )}

        <button type="submit" className="btn btn-primary w-100">
          {/* {loading ? "Registering..." : "Register"} */}
          Register
        </button>
      </motion.form>
    </div>
  );
}
